import styled from 'styled-components'

export const Grid = styled.div`
  column-count: 1;
  @media (min-width: 769px) {
    column-count: 2;
    column-gap: 2em;
  }
`

export const GridItem = styled.div`
  break-inside: avoid;
`

export const Title = styled.h1`
  font-weight: bold;
  text-align: center;
  font-size: 1.725rem;
  margin-bottom: 1.5em;
`

export const ImageContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: all .5s;

  &:hover {
    transform: scale3d(1.01, 1.01, 1);
  }
`
